import type { Portfolio } from '@blk/aw-bff-typescript-models';
import { getPortfolio } from '../../api/AWPortfolio/Portfolios';
import { portfolioQueryKeys } from './queryKeys';
import type { PortfolioQueryParams } from './types';

/**
 * TanStack Query object for fetching a portfolio by ID.
 * Use with useSuspenseQuery or useQuery in components.
 */
export const getPortfolioQuery = (params: PortfolioQueryParams) => ({
  queryKey: portfolioQueryKeys.byId(params),
  queryFn: async (): Promise<Portfolio> => {
    const { tag, portfolioId, origin, pkg, asOf } = params;
    const response = await getPortfolio(tag, portfolioId, { origin, pkg, asOf });
    return response.data;
  },
});
